<template>
<section class="container">
  <div class="mdl-grid mdl-grid--no-spacing center-items">
      <div class="mdl-cell mdl-cell--8-col mdl-card mdl-shadow--16dp">
        <header class="mdl-grid mdl-cell mdl-cell--12-col mdl-card__title mdl-card--border">
          <h3 class="mdl-cell mdl-cell--12-col mdl-card__title-text">
              Your Bill: {{ sequenceNumber | formatSequenceNumber }}
          </h3>
          <h5 class="mdl-cell mdl-cell--12-col mdl-card__subtitle-text">Name: {{`${firstname} ${lastname}` | uppercase}}</h5>
        </header>
        <div id="print">
        <div class="mdl-grid center-items mdl-cell mdl-cell--7-col mdl-card__supporting-text">
          <div class="tb-con mdl-cell mdl-cell--12-col">
            <table class="fullwidth mdl-data-table mdl-js-data-table">
              <tbody>
                <tr>
                  <td colspan="4" id="title" class="mdl-cell mdl-cell--12-col center-items title mdl-card__subtitle-text">
                    <img v-bind:src="image" class="mdl-cell mdl-cell--10-col"/>
                  </td>
                </tr>
                <tr>
                  <td class="mdl-data-table__cell--non-numeric">Bill Number:</td>
                  <td class="mdl-data-table__cell--non-numeric">{{ sequenceNumber | formatSequenceNumber }}</td>
                  <!-- <td class="mdl-data-table__cell--non-numeric">Bill Identifier:</td>
                  <td class="mdl-data-table__cell--non-numeric">{{ slug || 'Not Available' }}</td> -->
                </tr>
                <tr>
                  <td class="mdl-data-table__cell--non-numeric">Vehicle Number:</td>
                  <td class="mdl-data-table__cell--non-numeric">{{ vehiclenumber | uppercase }}</td>
                </tr>
                <tr>
                  <td class="mdl-data-table__cell--non-numeric">Name:</td>
                  <td class="mdl-data-table__cell--non-numeric">{{`${firstname} ${lastname}` | titlecase }}</td>
                  <!-- <td class="mdl-data-table__cell--non-numeric">e-mail:</td>
                  <td class="mdl-data-table__cell--non-numeric">{{ emailaddress || 'Not Available' }}</td> -->
                </tr>
                <tr>
                  <td class="mdl-data-table__cell--non-numeric">Phone:</td>
                  <td class="mdl-data-table__cell--non-numeric">{{ phonenumber }}</td>
                </tr>
                <tr>
                  <td class="mdl-data-table__cell--non-numeric">Date:</td>
                  <td class="mdl-data-table__cell--non-numeric">{{timestamp | formatDate}}</td>
                </tr>
                <tr>

                  <td class="mdl-data-table__cell--non-numeric">Amount:</td>
                  <td class="mdl-data-table__cell--non-numeric">{{ amount | currency }}</td>
                </tr>
                </tr>
                <tr>
                  <td colspan="4" class="mdl-data-table__cell--non-numeric">It is a Computer generated invoice, Please refer the identifiers</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tb-con mdl-cell mdl-cell--12-col">
            <table class="fullwidth mdl-data-table mdl-js-data-table">
              <thead>
                <tr>
                  <th class="mdl-data-table__cell--non-numeric">Name</th>
                  <th>Quantity</th>
                  <th>Unit price</th>
                  <th>Cost</th>
                </tr>
              </thead>
              <tbody>
                <tr id="last-line" v-for="key in items">
                  <td class="mdl-data-table__cell--non-numeric">{{ key.name | titlecase }}</td>
                  <td>{{ key.qty }}</td>
                  <td>{{ key.unitPrice | currency}}</td>
                  <td>{{ key.unitPrice * key.qty | currency }}</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
        </div>
        <div class="mdl-grid mdl-card__actions mdl-card--border">
          <div v-mdl class="mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
           @click="print">Print Bill</div>
           <router-link v-mdl class="mdl-cell mdl-cell--6-col mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
            v-bind:to="{ name: 'home'}">Back</router-link>
        </div>
      </div>
  </div>
</section>
</template>

<script>
import {MyApp} from '../main.js'
import deiva from '@/assets/DEIVA.png'
// import 'firebase/firestore'

// require('material-design-lite')
export default {
  name: 'view-bill',
  data () {
    return {
      firstname: '',
      lastname: '',
      emailaddress: '',
      phonenumber: '',
      amount: '',
      items: [],
      slug: '',
      timestamp: '',
      vehiclenumber: '',
      sequenceNumber: 0,
      success: (this.$route.params.success),
      style: {
        backgroundImage: 'url(' + deiva + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'inherit',
        backgroundPosition: 'center'
      },
      image: deiva
    }
  },
  beforeRouteEnter (to, from, next) {
    console.log(to.params.company)
    console.log(to.params.bill)
    const doc = MyApp.vue.$store.state.newBillState // MyApp.vue.$store.state.billsData.bills[to.params.bill]
    console.log(MyApp.vue.$store.state.newBillState)
    next(vm => {
      vm.firstname = doc.firstname
      vm.lastname = doc.lastname
      vm.emailaddress = doc.emailaddress
      vm.phonenumber = doc.phonenumber
      vm.amount = doc.amount
      vm.slug = doc.slug
      vm.timestamp = doc.timestamp
      vm.items = doc.items
      vm.vehiclenumber = doc.vehiclenumber
      vm.sequenceNumber = doc.sequenceNumber
    })
    // MyApp.vue.$store.dispatch('billData/openDBChannel', {companyId: to.params.company, billId: to.params.bill}).then(
    //   () => {
    //     next(vm => { // whereFilters: ['slug', '==', '{slug}']
    //       let doc = MyApp.vue.$store.state.billData.bill
    //       console.log(doc)
    //       vm.firstname = doc.firstname
    //       vm.lastname = doc.lastname
    //       vm.emailaddress = doc.emailaddress
    //       vm.phonenumber = doc.phonenumber
    //       vm.amount = doc.amount
    //       vm.slug = doc.slug
    //       vm.timestamp = doc.timestamp
    //       vm.items = doc.items
    //       vm.vehiclenumber = doc.vehiclenumber
    //       vm.sequenceNumber = doc.sequenceNumber
    //     })
    //   }
    // ).catch(console.error)

    // db.collection('companies/' + to.params.company + '/bills').where('slug', '==', to.params.bill).get().then((querySnapshot) => {
    //   querySnapshot.forEach((doc) => {
    //     next(vm => {
    //       vm.firstname = doc.data().firstname
    //       vm.lastname = doc.data().lastname
    //       vm.emailaddress = doc.data().emailaddress
    //       vm.phonenumber = doc.data().phonenumber
    //       vm.amount = doc.data().amount
    //       vm.slug = doc.data().slug
    //       vm.timestamp = doc.data().timestamp
    //       vm.items = doc.data().items
    //       vm.vehiclenumber = doc.data().vehiclenumber
    //       vm.sequenceNumber = doc.data().sequenceNumber
    //     })
    //   })
    // })
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      // db.collection('companies/' + this.$root.$data.user.company + '/bills').where('slug', '==', this.$route.params.bill).get().then((querySnapshot) => {
      //   querySnapshot.forEach((doc) => {
      //     console.log(doc.id, ' => ', doc.data())
      //     this.firstname = doc.data().firstname
      //     this.lastname = doc.data().lastname
      //     this.emailaddress = doc.data().emailaddress
      //     this.phonenumber = doc.data().phonenumber
      //     this.amount = doc.data().amount
      //     this.items = doc.data().items
      //     this.slug = doc.data().slug
      //     this.timestamp = doc.data().timestamp
      //     this.vehiclenumber = doc.data().vehiclenumber
      //     this.sequenceNumber = doc.data().sequenceNumber
      //     this.success = this.$route.params.success
      //   })
      // })
      console.log(this.$route.params.company)
      console.log(this.$route.params.bill)
      // MyApp.vue.$store.dispatch('billData/openDBChannel', {companyId: this.$route.params.company, billId: this.$route.params.bill}).then(
      //   () => {
      //     // whereFilters: ['slug', '==', '{slug}']
      //     let doc = MyApp.vue.$store.state.billData.bill
      //     console.log(doc)
      //     this.firstname = doc.firstname
      //     this.lastname = doc.lastname
      //     this.emailaddress = doc.emailaddress
      //     this.phonenumber = doc.phonenumber
      //     this.amount = doc.amount
      //     this.slug = doc.slug
      //     this.timestamp = doc.timestamp
      //     this.items = doc.items
      //     this.vehiclenumber = doc.vehiclenumber
      //     this.sequenceNumber = doc.sequenceNumber
      //   })
      //   .catch(console.error)
      const doc = MyApp.vue.$store.state.newBillState
      console.log(doc)
      this.firstname = doc.firstname
      this.lastname = doc.lastname
      this.emailaddress = doc.emailaddress
      this.phonenumber = doc.phonenumber
      this.amount = doc.amount
      this.slug = doc.slug
      this.timestamp = doc.timestamp
      this.items = doc.items
      this.vehiclenumber = doc.vehiclenumber
      this.sequenceNumber = doc.sequenceNumber
    },
    print () {
      this.$htmlToPaper('print')
    }
  },
  created () {
    this.$nextTick(() => {
      window.componentHandler.upgradeDom()
      window.componentHandler.upgradeAllRegistered()
    })
  }
}
</script>

<style scoped>
/* section {
    height: 100vh;
    max-width: 900px;
    margin: 0 auto;
}
h1 {
    font-size: 30px;
    margin: 30px 0;
}
p {
    margin-bottom: 20px;
}
.contact--section {
    background-color: white;
    padding: 20px;
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
    .__name {
        font-size: 30px;
    }
}

table {
    border: 2px solid #42b983;
    border-radius: 3px;
    background-color: #fff;
    margin: auto;
}

th {
    background-color: #42b983;
    color: rgba(255,255,255,0.66);
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

td {
    background-color: #f9f9f9;
}

td,
th {
    min-width: 120px;
    padding: 10px 20px;
}
#bill-items{
  overflow-x: auto;
} */

/* table{
  width:100%;

} */
.tb-con{
  overflow-x: scroll;
}
.fullwidth { width: 100%; }
.mdl-grid{
  margin: 8px;
}
.title{
  text-align: center;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/ViewBill.vue